import PropTypes from 'prop-types';
import { getTimezoneOffsetTimeFromTime } from 'src/utils/time';

const FormatTime = ({ time }) => {
    const localTime = getTimezoneOffsetTimeFromTime(time);
    const timeObject = localTime.split(':');

    return `${timeObject[0]}:${timeObject[1]}`;
};

FormatTime.propTypes = {
    time: PropTypes.string.isRequired
};

export default FormatTime;
